import { createContext, useContext } from 'react';
import { User } from 'firebase/auth';

// Normalized user that mirrors the properties the app uses
// Maps Firebase User properties to the shape the rest of the app expects
export interface AppUser {
  id: string; // Firebase uid
  email: string | null;
  user_metadata: {
    full_name: string | null;
    name: string | null;
    avatar_url: string | null;
  };
  // Keep the raw Firebase user accessible
  _raw: User;
}

interface AuthContextType {
  user: AppUser | null;
  isLoading: boolean;
  signOut: () => Promise<void>;
  signInWithEmail: (email: string, password: string) => Promise<void>;
  signUpWithEmail: (email: string, password: string) => Promise<void>;
  signInWithGoogle: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
